import React from 'react';

export const ChevronUp = (props: { className?: string }) => {
    return (
        <svg
            className={props.className}
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M1 7L7 1L13 7'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default ChevronUp;
